import React, { Component } from 'react';
import queryString from 'query-string';
import { needFlags } from "../util/flagcalc";
import Styles from "../Styles.js";
import { GlobalContext } from '../global-context.js';

class RotatePIContainer extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            project: null
        };
    }

    componentDidMount() {
        const values = queryString.parse(this.props.location.search);
        const pid = values.project;
        fetch(`/api/project/${pid}`)
            .then(res => res.json())
            .then(proj => {
                this.setState({
                    id: pid,
                    project: proj
                });
            });
    }

    render() {
        if (!(this.state.id)) {
            return null
        }
        const { project } = this.state;
        const { config, person } = this.context;
        const { navigate } = this.props;

        let sigsRequired = null;
        const flagsNeeded = needFlags(project, person, config).switchPIflagsNeeded;
        if (flagsNeeded.length > 0) {
            sigsRequired = <div>
                <h2 style={{color: "#800"}}>ACTION REQUIRED - Document Signatures Needed:</h2>
                {
                    flagsNeeded.map(needFlag => {
                        return (
                            <div key={needFlag}
                              onClick={() => navigate(`sign?project=${project.id}&document=${needFlag}`)}
                              className="project-sensitivity"
                              style={{cursor: "pointer", padding: "10px", marginBottom: "25px", width: "250px"}}>
                                Sign &#8594; {needFlag}
                            </div>
                        );
                    })
                }
            </div>
        }

        return (
            <div style={{padding: "20px"}}>
              <Styles>
                <h1>{project.title}</h1>
                <h2>Signatures Required for PI Rotation</h2>
                {sigsRequired}
              </Styles>
            </div>
        );
    }
}

export default RotatePIContainer;
